module.exports = __webpack_public_path__ + "static/img/coupon_gold.3621f18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/coupon_gold.png
// module id = z2t9
// module chunks = 4